import { action } from '@sas/nova-commons/action';
const Transition = 'report-container/transitionSection';
const TransitionComplete = 'report-container/transitionComplete';
function init(current) {
    return {
        current,
    };
}
const actions = {
    Transition: Transition,
    createTransition(payload) {
        return action(actions.Transition, payload);
    },
    TransitionComplete: TransitionComplete,
    createTransitionComplete() {
        return action(actions.TransitionComplete);
    },
};
function transitionReducer(prevState, anyAction) {
    const action = anyAction;
    switch (action.type) {
        case actions.Transition: {
            if (prevState.current === action.payload) {
                return prevState;
            }
            return Object.assign(Object.assign({}, prevState), { next: action.payload });
        }
        case actions.TransitionComplete: {
            if (prevState.next === undefined) {
                return prevState;
            }
            const current = prevState.next;
            return {
                current,
                next: undefined,
            };
        }
        default:
            return prevState;
    }
}
export const TransitionState = {
    actions,
    init,
    reducer: transitionReducer,
    selectors: {
        getLatest(state) {
            if (state.next !== undefined) {
                return state.next;
            }
            return state.current;
        },
        getOrderedSections(state) {
            if (state.next === undefined) {
                return [state.current];
            }
            return [state.current, state.next];
        },
        transitioning(state) {
            return state.next !== undefined;
        },
    },
};
